import { T } from "@/components/T";

export function CraftEditorial() {
  return (
    <div className="relative overflow-hidden" style={{ height: "clamp(300px, 45vw, 580px)" }}>
      <img loading="lazy" src="/assets/fotos/hb-foto-4.webp" alt="Holzbuddy Zimmerer bei der Arbeit – Südtirol"
        className="w-full h-full object-cover" style={{ objectPosition: "center 25%" }} />
      <div className="absolute inset-0" style={{ background: "linear-gradient(to right, rgba(11,12,14,0.55) 0%, transparent 50%, rgba(11,12,14,0.15) 100%)" }} />
      <div className="absolute inset-0" style={{ background: "linear-gradient(to top, rgba(11,12,14,0.6) 0%, transparent 50%)" }} />
      <div className="absolute bottom-0 left-0 container-hb pb-10 md:pb-14">
        <p className="text-[9px] tracking-[0.25em] uppercase font-inter mb-2" style={{ color: "rgba(245,200,0,0.55)" }}>
          <T de="Handwerk · Südtirol" it="Artigianato · Alto Adige" />
        </p>
        <p className="font-bebas text-white leading-none" style={{ fontSize: "clamp(32px, 5vw, 68px)" }}>
          <T de={<>Jeder Balken sitzt.<br /><span style={{ color: "#f5c800" }}>Jedes Detail zählt.</span></>}
             it={<>Ogni trave è al suo posto.<br /><span style={{ color: "#f5c800" }}>Ogni dettaglio conta.</span></>} />
        </p>
      </div>
    </div>
  );
}
